import { useMemo } from "react"

import { useAgentById } from "@/organisms/Drawers/applications/ai-discovery/useAiDiscovery"
import { getHardeningSuggestions } from "@/pages/GovernancePage/applications/policies/getHardeningSuggestions"
import { useAiPolicies } from "@/pages/GovernancePage/applications/policies/useAiPolicies"

import type { HardeningSuggestion } from "@/pages/GovernancePage/applications/policies/getHardeningSuggestions.types"

const NO_SUGGESTIONS: HardeningSuggestion[] = []

// The hardening rules the agent's own policy does not hold yet.
export const useHardening = (props: { record?: { id: string } }) => {
  const { data: agent } = useAgentById(props)
  const { isPending, findAgentPolicy } = useAiPolicies()
  const ownPolicy = agent ? findAgentPolicy(agent.name) : undefined

  const suggestions = useMemo(
    () =>
      agent && !isPending
        ? getHardeningSuggestions({ agent, ownPolicy })
        : NO_SUGGESTIONS,
    [agent, isPending, ownPolicy]
  )

  return { agent, suggestions }
}
